import dateFnsFormat from 'date-fns/format';
import { ptBR } from 'date-fns/locale';
const config = { locale: ptBR };

export const formatDate = (date: number | Date, format: string) =>
  dateFnsFormat(date, format, config);
